<template>
  <div class="box  box--gray">

    <ul class="box__list">
      <li v-for="item in cart.items" class="box__list-item">
        <div class="box__item-title">
          {{ item.product.title }}
        </div>
        <span>{{ item.formatted_price_with_tax }}</span>
      </li>
    </ul><!-- ./box__list -->

    <div class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_product_quantity'] }}</div>
          <span>{{ cart.total_quantity }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_price_without_tax'] }}</div>
          <span>{{ cart.formatted_total_price }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_tax_rate'] }}</div>
          <span>{{ cart.formatted_tax_price }}</span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.shipping_method" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_shipping'] }}</div>
          <span>
            {{ cart.formatted_shipping_price_with_tax }}
          </span>
        </li>
        <li v-if="cart.shipping_method" class="box__list-item">
          <div class="fw-500 text-gray-dark">
            {{ cart.shipping_method.title }}
          </div>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.coupon_total_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_discount_price_wit_tax'] }}</div>
          <span class="discount_total_price">
            - {{ cart.formatted_coupon_total_price_with_tax }}
          </span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div class="box__section">
      <ul class="box__list ">
        <li class="box__list-item  box__list-item--accent">
          <div>{{ in18['page_summary_total_price'] }}</div>
          <div><b class="text-dark">{{ cart.formatted_total_price_with_tax }}</b></div>
        </li>
      </ul>

      <button :disabled="inProgress" class="hidden transition-colors duration-200 align-top border border-transparent large:block text-center rounded-[5px] font-medium mb-2 leading-[1.25rem] btn--green  w-full  btn--sm "
              type="button"
              @click="callProcessCheckout">
        {{ in18['page_summary_process_checkout_btn'] }}
      </button>

      <div class="text-center">
        <a :title="in18['page_summary_continue_shipping']" class="link  link--gray  text-sm hidden large:block"
           href="/">
          {{ in18['page_summary_continue_shipping'] }}
        </a>
      </div>
    </div><!-- ./box__section -->
  </div><!-- ./box -->
</template>

<script>

export default {

  name: "CheckoutSummary",

  props: {
    cart:       {
      type: Object
    },
    in18:       {
      type: Object
    },
    inProgress: {
      type: Boolean
    }
  },

  emits: [
    'process-checkout'
  ],

  methods: {
    callProcessCheckout() {
      this.$emit('process-checkout'); // Emit an event to call the parent method
    }
  }
};
</script>
